<template lang="pug">
  include ./../../../mixins
  +b.popup-inner.modal-form-community
    +e.close-popup(@click='closeModal()')
    +b.el.wrap
      +b.cards-technologies.modal-technologies
        +b.icon.modal-mobile(v-html="icon")
        +b.el--p_h_lg-xl.--p_h_sm.modal-mobile
          +b.line--technologies
        +b.H3.ds-caption--size_3xl-lg.--size_lg.--w_r.--c_white.--upp.--h_130 {{title}}
        +b.el--p_t_md
          +b.P.ds-caption--c_white.--w_l.--size_md-lg.--size_1xs.--h_200(v-html="text" )
    slot(
      name="content"
    )
</template>

<script>
export default {
  data() {
    return {
    }
  },
  props: {
    icon: {},
    title: {},
    text: {},
  },
  methods: {
    closeModal() {
      this.$nextTick(() => {
        this.$emit('close')
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// ./src/js/components/app/Modals/ModalTecnologies.vue